var _rect, _path, _path2, _rect2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgEmptyRecurring = function SvgImgEmptyRecurring(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.8,
    y: 9.8,
    width: 39.4,
    height: 47.4,
    rx: 3.2,
    fill: "#fff",
    stroke: "#BDBDBD",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 49.6h-.4V55a1.4 1.4 0 0 0 1.4 1.4h35a1.4 1.4 0 0 0 1.4-1.4v-5.4H11z",
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    stroke: "#BDBDBD",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.333 33.667H49M14.333 45.667h9.334M14.333 41.667h9.334M14.333 37.667h16",
    stroke: "#BDBDBD",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8,
    y: 22.8,
    width: 39.4,
    height: 47.4,
    rx: 3.2,
    fill: "#fff",
    stroke: "#BDBDBD",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 62.6h-.4V68a1.4 1.4 0 0 0 1.4 1.4h35a1.4 1.4 0 0 0 1.4-1.4v-5.4H32z",
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    stroke: "#BDBDBD",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.333 46H70M35.333 58h9.334M35.333 54h9.334M35.333 50h16",
    stroke: "#BDBDBD",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgEmptyRecurring);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img_empty_recurring.20fa1f0b3da3adcfa8061ab3adc13d6c.svg";